import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OverlayService } from './overlay.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sc-overlay',
  styleUrls: ['./overlay.component.css'],
  templateUrl: './overlay.component.html'
})
export class OverlayComponent implements OnInit {
  public message: string;
  public show = false;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private overlayService: OverlayService,
    private cd: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.router.events.subscribe(() => {
      this.show = false;
    });

    this.overlayService.showEvent.subscribe((message?: string) => {
      this.message = message || this.message;
      this.show = true;
      this.cd.detectChanges();
    });

    this.overlayService.hideEvent.subscribe(() => {
      this.show = false;
    });

    this.overlayService.setMessageEvent.subscribe((message: string) => {
      this.message = message;
    });
  }
}
